// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2jIku","row":"styles_row__2iZ7q"};